import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, Search, Filter, PlayCircle, Clock, ShieldCheck, FolderKanban, Users, BarChart3, FileText, Lock } from 'lucide-react';
import { Button } from './ui/Button';
import { Badge } from './ui/Badge';
import { AgencyModal } from './AgencyModal';
import { motion } from 'framer-motion';
export const Audiences = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-149" data-mp="2kkg9vrzs0bcz">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-150" data-mp="2klhx0uu2gob2" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151" data-mp="25w287ke3isy0">
        {/* Why Work with Talent Agencies */}
        <div className="mb-32" data-id="element-152" data-mp="2atu40phv2z7h">
          <div className="flex flex-col lg:flex-row-reverse gap-16 items-center" data-id="element-153" data-mp="2auwrenfz6jin">
            <div className="w-full lg:w-1/2" data-id="element-154" data-mp="1ww5e338xt1vk">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-155" data-mp="20wfw5ea07iqs">
                Why work with talent agencies?
              </h2>
              <p className="text-lg text-gray-600 mb-6" data-id="element-156" data-mp="2d2ye78q7ldz3">
                Get fast responses and more reliable relationships you can count
                on. Talent managers on Zano actively manage their rosters and
                respond directly to brand inquiries — faster, professional
                responses from the people who know their creators best.
              </p>
              <p className="text-base text-gray-600 mb-6" data-id="element-157" data-mp="1ucqi3akxfnse">
                Not only do they give you access to the industry's top creators,
                they're business people who understand your goals and needs.
                Their job is to sell their creators. The creators' job is
                to work on their content. You get the best of the best and talk
                directly to who handles it.
              </p>
              <p className="text-base text-gray-700 font-medium mb-6" data-id="element-158" data-mp="1blh70wvicqyp">
                The Talent Agency Directory lists all 400+ talent agencies on
                Zano with their main point of contact, website, and total roster
                following.
              </p>
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 mb-6 flex items-start gap-3" data-id="element-159" data-mp="20cmux43wbfsf">
                <div className="p-1.5 bg-white rounded-md shadow-sm shrink-0" data-id="element-160" data-mp="25566xwmxq2v4">
                  <Lock size={14} className="text-gray-500" data-id="element-161" data-mp="2a3r9i2pnsymq" />
                </div>
                <p className="text-xs text-gray-600 leading-relaxed" data-id="element-162" data-mp="1dcytt66n18lh">
                  <span className="font-semibold text-gray-900" data-id="element-163" data-mp="1des2er0ta2w4">
                    Approved access required.
                  </span>{' '}
                  Anyone can post a casting call to our network of agencies, but
                  viewing the premium roster database and talent agency
                  directory requires an approved brand account.
                </p>
              </div>
              <Link to="/pricing" data-id="element-164" data-mp="2xskbafsyq0p9">
                <Button variant="primary" data-id="element-165" data-mp="32rn2oxg0s8er">Start Free Trial</Button>
              </Link>
            </div>

            <div className="w-full lg:w-1/2" data-id="element-166" data-mp="r4a2mmgkwesv">
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-167" data-mp="r40fr7qtynre">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-168" data-mp="m5ytyf20sac8">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-169" data-mp="hd5n9lmzqrxi">
                    <div className="flex items-center gap-2" data-id="element-170" data-mp="cdkpvfngyrmw">
                      <Users size={16} className="text-gray-500" data-id="element-171" data-mp="8f3lv4zchx9p" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-172" data-mp="3f8r2qcg8njd">
                        Talent Agency Directory
                      </span>
                    </div>
                    <Badge className="bg-purple-100 text-purple-800 border border-purple-200" data-id="element-173" data-mp="3un3dgrhz2pjc">
                      400+ Agencies
                    </Badge>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-174" data-mp="1srt2aheizkkt">
                    <table className="w-full text-left text-sm whitespace-nowrap" data-id="element-175" data-mp="1nukf22eisqcp">
                      <thead className="bg-gray-50 border-b border-gray-100 text-xs text-gray-500 uppercase" data-id="element-176" data-mp="1vuywitssab8x">
                        <tr data-id="element-177" data-mp="20uv22xh4qaql">
                          <th className="px-4 py-3 font-medium" data-id="element-178" data-mp="20u35pkfpk8z9">Agency</th>
                          <th className="px-4 py-3 font-medium" data-id="element-179" data-mp="1lwaq6sa5vkl2">Main POC</th>
                          <th className="px-4 py-3 font-medium" data-id="element-180" data-mp="1qvw1812lvje5">Website</th>
                          <th className="px-4 py-3 font-medium" data-id="element-181" data-mp="1qy8hm9sptlp3">
                            Total Following
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-182" data-mp="1hxk3lf3bnlc7">
                        <tr data-id="element-183" data-mp="138e6bwo1o56y">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-184" data-mp="13502ejzqfnxe">
                            Clicks Talent
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-185" data-mp="u77nvi1u4kb2">
                            John Marcus
                          </td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-186" data-mp="y9uejfmrrz6o">
                            clickstalent.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-187" data-mp="alxl17x1b7c0">
                            14.2M
                          </td>
                        </tr>
                        <tr data-id="element-188" data-mp="jkroni8s8xz2">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-189" data-mp="jjhqyu5udrsy">
                            Viral Nation
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-190" data-mp="tjh12vhwtq7x">Ena</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-191" data-mp="the945x75n0k">
                            viralnation.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-192" data-mp="139k0bdfmk0ep">
                            28.5M
                          </td>
                        </tr>
                        <tr data-id="element-193" data-mp="1carm4w0yf8rw">
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-194" data-mp="1cbjii92dlaj8">
                            Boost Society
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-195" data-mp="dxe0su17b83x">Josh</td>
                          <td className="px-4 py-3 text-blue-600 hover:underline cursor-pointer" data-id="element-196" data-mp="iwyyl14mxaf2">
                            boost-society.com
                          </td>
                          <td className="px-4 py-3 font-medium text-gray-900" data-id="element-197" data-mp="np07cd2lgj0c">
                            8.1M
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* For Talent Agencies */}
        <div className="bg-gray-900 text-white rounded-3xl p-8 lg:p-12 -mx-4 sm:mx-0" data-id="element-198" data-mp="16li3d6oh752e">
          <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-199" data-mp="33fmmzma00ssz">
            <div className="w-full lg:w-1/2" data-id="element-200" data-mp="38do6u9f90w5i">
              <Badge className="mb-4 bg-gray-800 text-gray-300 border border-gray-700" data-id="element-201" data-mp="38eg4dpsep3yf">
                For Talent Agencies
              </Badge>
              <h2 className="text-3xl font-bold text-white mb-4" data-id="element-202" data-mp="2w3orb0qhsqkp">
                Turn every creator into a live, bookable asset
              </h2>
              <p className="text-lg text-gray-400 mb-6" data-id="element-203" data-mp="2r5dh2owace1y">
                Showcase your roster, maintain living media kits, and receive
                qualified campaign opportunities from brands.
              </p>
              <div className="grid grid-cols-1 gap-4 mb-8" data-id="element-204" data-mp="3jshsbblz1om6">
                {['Roster management — manage your roster internally with live performance data in one clean, easy-to-scan table', 'Get your creators deals from brands/marketing agencies on Zano', 'Get live public media kits you can share externally', 'Submit creators to exclusive casting calls'].map((item, idx) => <div key={idx} className="flex items-start gap-3 text-sm text-gray-300" data-id="element-205" data-mp="1uda1w4quq2fe" data-mpi={idx}>
                    <CheckCircle2 size={18} className="text-zano-pink shrink-0 mt-0.5" data-id="element-206" data-mp="2cs50xrsrl69" />
                    <span data-id="element-207" data-mp="3kjpyy7w5o9g1">{item}</span>
                  </div>)}
              </div>
              <div className="flex flex-col sm:flex-row items-center gap-4 mb-4" data-id="element-208" data-mp="3piaqzk197mte">
                <Link to="/list-your-roster" className="w-full sm:w-auto" data-id="element-209" data-mp="h1fzt1ttjqv5">
                  <Button variant="secondary" className="w-full sm:w-auto border-gray-700 text-white hover:bg-gray-800" data-id="element-210" data-mp="l31g6x5kana3">
                    Learn More
                  </Button>
                </Link>
                <Button variant="primary" className="w-full sm:w-auto" onClick={() => setIsModalOpen(true)} data-id="element-211" data-mp="c94zhxv62322">
                  List Your Agency
                </Button>
              </div>
              <p className="text-sm text-gray-400" data-id="element-212" data-mp="1e5amhtchalue">
                Want to see how it works?{' '}
                <a href="https://www.youtube.com/watch?v=d0T7ZbxsxrY" target="_blank" rel="noopener noreferrer" className="text-zano-pink hover:text-zano-pinkDark font-medium underline underline-offset-2 inline-flex items-center gap-1" data-id="element-213" data-mp="1a5a8uax7eeoe">
                  <PlayCircle size={15} data-id="element-214" data-mp="v7q7rf3fh3ni" /> Watch a demo video
                </a>
              </p>
            </div>

            <div className="w-full lg:w-1/2 relative" data-id="element-215" data-mp="r7pkd4ycpi4b">
              {/* Product UI Mockup: Talent Agency Roster Dashboard with Profile Header Layer */}
              <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-inner" data-id="element-216" data-mp="1061h7opt9c57">
                <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden" data-id="element-217" data-mp="2gjrqd9vseqlp">
                  <div className="border-b border-gray-100 p-4 bg-gray-50/50 flex justify-between items-center" data-id="element-218" data-mp="2bm9gnh9y47cn">
                    <div className="flex items-center gap-2" data-id="element-219" data-mp="1le2j4vdzb749">
                      <Users size={16} className="text-gray-500" data-id="element-220" data-mp="1ggkkpyxl8aai" />
                      <span className="font-semibold text-sm text-gray-800" data-id="element-221" data-mp="1gidq7awgsogx">
                        My Roster
                      </span>
                    </div>
                    <Button variant="primary" className="text-xs px-3 py-1.5 h-auto" data-id="element-222" data-mp="16ppvclp1ouku">
                      + Add creator
                    </Button>
                  </div>

                  <div className="p-0 overflow-x-auto" data-id="element-223" data-mp="xs5tpbn9sw9p">
                    <table className="w-full text-left text-xs whitespace-nowrap" data-id="element-224" data-mp="srhrdttlct06">
                      <thead className="bg-gray-50 border-b border-gray-100 text-gray-500 uppercase" data-id="element-225" data-mp="nseyf7qvyd8k">
                        <tr data-id="element-226" data-mp="2n4zfpj1tltw9">
                          <th className="px-4 py-3 font-medium" data-id="element-227" data-mp="2n3y6lk4d7hh6">Name</th>
                          <th className="px-4 py-3 font-medium" data-id="element-228" data-mp="2i6po1ifb1bfe">Category</th>
                          <th className="px-4 py-3 font-medium" data-id="element-229" data-mp="2qn6puvgetgjc">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1248.png" alt="TikTok" className="w-3 h-3 inline-block" data-id="element-230" data-mp="2qkkh4shs8uzj" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-231" data-mp="27o2idr4inuts">
                            <img src="https://cdn.magicpatterns.com/patterns/figma-images/HPPMfQF9zbBNm5oHh69dtz/362-1249.png" alt="Instagram" className="w-3 h-3 inline-block" data-id="element-232" data-mp="27pvs5fafev60" />
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-233" data-mp="3s3mn565tzn3l">
                            <svg className="w-3.5 h-3.5 inline-block text-[#FF0000]" viewBox="0 0 24 24" fill="currentColor" aria-label="YouTube" data-id="element-234" data-mp="3s3ebfhlg2ntz">
                              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" data-id="element-235" data-mp="32f8v4hvhf3f5" />
                            </svg>
                          </th>
                          <th className="px-4 py-3 font-medium" data-id="element-236" data-mp="2yef8drtrzunu">Status</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-100" data-id="element-237" data-mp="2tlm1oyeqyc94">
                        <tr className="hover:bg-gray-50" data-id="element-238" data-mp="25x2w4qn30dkq">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-239" data-mp="25vi16zwuusmc">
                            <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-240" data-mp="20xzw5klykxjm" />
                            <span className="font-medium text-gray-900" data-id="element-241" data-mp="6g83t0m06bh7">
                              Elena Rodriguez
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-242" data-mp="z7rnsmqfbtk9">Fashion</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-243" data-mp="144qj38ltq6k1">1.2M</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-244" data-mp="q6tmic7de05d">340K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-245" data-mp="u7vimk5zpw34">-</td>
                          <td className="px-4 py-3" data-id="element-246" data-mp="u62f3dqobrzc">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-247" data-mp="3aw9gfg1vy4z8">
                              Live
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-248" data-mp="3v7c0h2lh787b">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-249" data-mp="3qdhgrz5vet88">
                            <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-250" data-mp="3lewiw6e3clmy" />
                            <span className="font-medium text-gray-900" data-id="element-251" data-mp="d0nwjg25wr38">
                              Marcus Chen
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-252" data-mp="3zhcwy47v05r">Tech</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-253" data-mp="2sqs8x8ohlmeg">850K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-254" data-mp="2ss3ar2ydgk2x">120K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-255" data-mp="2oodsev8aiyqc">2.1M</td>
                          <td className="px-4 py-3" data-id="element-256" data-mp="147xihjopfccw">
                            <Badge className="bg-orange-50 text-orange-700 border border-orange-200 text-[10px] px-2 py-0.5" data-id="element-257" data-mp="1451mw20bwzrm">
                              Action Required
                            </Badge>
                          </td>
                        </tr>
                        <tr className="hover:bg-gray-50" data-id="element-258" data-mp="1hzb20xmm4a7x">
                          <td className="px-4 py-3 flex items-center gap-2" data-id="element-259" data-mp="1mxw12tq4onus">
                            <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=40&q=80" alt="Creator" className="w-7 h-7 rounded-full object-cover shrink-0" data-id="element-260" data-mp="1mzyp587q06wv" />
                            <span className="font-medium text-gray-900" data-id="element-261" data-mp="1kj5q9mciitc">
                              Sarah Jenkins
                            </span>
                          </td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-262" data-mp="6l763lwgsc08">Lifestyle</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-263" data-mp="19ujpk37cl91t">450K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-264" data-mp="14wi6hi9x99qc">890K</td>
                          <td className="px-4 py-3 text-gray-600" data-id="element-265" data-mp="1ivhmk1jdcgaw">-</td>
                          <td className="px-4 py-3" data-id="element-266" data-mp="1dvv5ti4c0hxc">
                            <Badge className="bg-green-50 text-green-700 border border-green-200 text-[10px] px-2 py-0.5" data-id="element-267" data-mp="1dv3o9b7kkkq2">
                              Live
                            </Badge>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Floating Profile Header Layer */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} className="absolute -bottom-6 -right-4 sm:-right-8 w-80 bg-white rounded-xl border border-gray-200 shadow-[0_20px_40px_-15px_rgba(0,0,0,0.15)] p-4 z-20" data-id="element-268" data-mp="1xlyvs728waic">
                <div className="flex items-center gap-3" data-id="element-269" data-mp="2l9c5esirs3wc">
                  <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=64&h=64" alt="Elena Rodriguez" className="w-12 h-12 rounded-full object-cover shrink-0" data-id="element-270" data-mp="27etat392i4ol" />
                  <div className="min-w-0" data-id="element-271" data-mp="22fyklg8rtdug">
                    <h4 className="text-sm font-bold text-gray-900 leading-tight" data-id="element-272" data-mp="22h19jimj967q">
                      Elena Rodriguez
                    </h4>
                    <p className="text-xs font-medium text-gray-700" data-id="element-273" data-mp="1sj3nn1s5blia">
                      ABC Talent Agency
                    </p>
                    <span className="inline-flex items-center gap-1 mt-0.5 text-[10px] font-semibold text-emerald-600" data-id="element-274" data-mp="28wrvqowo82uo">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" data-id="element-275" data-mp="23wx7yu86ztdu" />
                      Exclusive
                    </span>
                    <p className="text-[11px] text-gray-500 mt-0.5 truncate" data-id="element-276" data-mp="1u1c0igkcu0wp">
                      john.smith@abctalent.com
                    </p>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};